import resizeImageSource from './resizeImageSource';

const resizeImage = (image, width, ratio) =>
  image && {
    id: image.id,
    url: resizeImageSource(image.url, width, ratio),
  };

export const convertTripleTeaserItems = (items) =>
  items.map((item, index) => {
    if (index === 0) {
      return {
        ...item,
        image: resizeImage(item.image, 780, 1),
      };
    }

    return {
      ...item,
      image: resizeImage(item.image, 640, 15 / 9),
    };
  });

export const convertSingleTeaserItem = (item) => ({
  ...item,
  image: resizeImage(item.image, 680),
});
